var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_5._Facebook",
    "data-name": "5. Facebook",
    d: "M51.5,103A51.513,51.513,0,0,1,31.454,4.047,51.513,51.513,0,0,1,71.546,98.953,51.178,51.178,0,0,1,51.5,103ZM34.611,44.028V55.442H44.636V83.033H56.975V55.442h9.2l1.751-11.414H56.975V36.622a6.39,6.39,0,0,1,1.378-4.254,6.355,6.355,0,0,1,5.056-1.912h4.979V20.739a61.628,61.628,0,0,0-8.838-.771c-9.339,0-14.914,5.743-14.914,15.362v8.7Z",
    fill: "#1778f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.95cf0069af5c269ab9465b762f91a0d8.svg";
export { ForwardRef as ReactComponent };